// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1bbfA","visuallyhidden":"_2w6md","hide-text":"zOCLK","center":"_29fwK","noprint":"_1PvdU","root":"AmCxV","aspectRatio":"_1rwmO","iframeContent":"_1525_"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-embed-content/styles/EmbedContent.scss
 ** module id = 940
 ** module chunks = 1
 **/